module.exports = __webpack_public_path__ + "img/person.d9dd9711.svg";